import TextViewer from "../../components/TextViever";

const WhyUs = () => {
  return <TextViewer obszar="us" />;
};

export default WhyUs;
